import { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { Menu, X, MessageCircle, Calendar } from 'lucide-react';
import { BUSINESS, telLink } from '../lib/business';
import { buildWhatsappUrl } from '../lib/whatsapp';

const NAV_ITEMS = [
  { to: '/servicios', label: 'Servicios' },
  { to: '/promociones', label: 'Promociones' },
  { to: '/precios', label: 'Precios' },
  { to: '/instalaciones', label: 'Instalaciones' },
  { to: '/nuestros-trabajos', label: 'Nuestros trabajos' },
  { to: '/nosotros', label: 'Nosotros' },
  { to: '/contacto', label: 'Contacto' },
];

const waLink = buildWhatsappUrl(BUSINESS.whatsapp, 'Hola Zenya, me gustaría agendar una cita.');

const navLinkStyle = ({ isActive }) => ({
  fontSize: 13.5,
  letterSpacing: '.06em',
  color: 'var(--ink-700)',
  textDecoration: 'none',
  paddingBottom: 3,
  borderBottom: `1px solid ${isActive ? 'var(--rose-500)' : 'transparent'}`,
});

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const goAgendar = () => {
    setMenuOpen(false);
    navigate('/agendar');
  };

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 40,
        background: 'rgba(252,250,248,.92)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid var(--ink-100)',
      }}
    >
      <div
        style={{
          maxWidth: 1240,
          margin: '0 auto',
          padding: '14px 5vw',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 24,
        }}
      >
        <Link to="/" onClick={() => setMenuOpen(false)} style={{ display: 'flex', alignItems: 'center' }}>
          <img
            src="/zenya-lockup-ink.png"
            alt="Zenya Nails &amp; Spa"
            style={{ height: 38, width: 'auto', display: 'block' }}
          />
        </Link>

        <nav className="z-header-nav" style={{ display: 'none', alignItems: 'center', gap: 26 }}>
          {NAV_ITEMS.map((n) => (
            <NavLink key={n.to} to={n.to} style={navLinkStyle}>
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="z-header-actions" style={{ display: 'none', alignItems: 'center', gap: 10 }}>
          <a
            href={waLink}
            target="_blank"
            rel="noreferrer"
            title="Escríbenos por WhatsApp"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              background: 'var(--rose-50)',
              border: '1px solid var(--rose-200)',
              color: 'var(--rose-700)',
              fontSize: 13,
              letterSpacing: '.06em',
              padding: '10px 18px',
              borderRadius: 'var(--radius-pill)',
              whiteSpace: 'nowrap',
            }}
          >
            <MessageCircle size={15} strokeWidth={1.9} />
            WhatsApp
          </a>
          <button
            onClick={goAgendar}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              background: 'var(--rose-700)',
              color: '#FFF',
              fontSize: 13,
              letterSpacing: '.06em',
              padding: '11px 20px',
              borderRadius: 'var(--radius-pill)',
              whiteSpace: 'nowrap',
              border: 'none',
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            <Calendar size={15} strokeWidth={1.8} />
            Agendar cita
          </button>
        </div>

        <button
          className="z-header-toggle"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Menú"
          style={{
            border: '1px solid var(--ink-200)',
            background: '#FFF',
            borderRadius: 'var(--radius-md)',
            width: 42,
            height: 42,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            color: 'var(--ink-800)',
          }}
        >
          {menuOpen ? <X size={20} strokeWidth={1.6} /> : <Menu size={20} strokeWidth={1.6} />}
        </button>
      </div>

      {menuOpen && (
        <div
          style={{
            borderTop: '1px solid var(--ink-100)',
            background: 'var(--cream)',
            padding: '18px 5vw 26px',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            animation: 'zRise 260ms var(--ease-out)',
          }}
        >
          {NAV_ITEMS.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              onClick={() => setMenuOpen(false)}
              style={{
                fontFamily: 'var(--font-display)',
                fontSize: 26,
                color: 'var(--ink-900)',
                textDecoration: 'none',
                padding: '9px 0',
                borderBottom: '1px solid var(--ink-100)',
              }}
            >
              {n.label}
            </Link>
          ))}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 18 }}>
            <button
              onClick={goAgendar}
              style={{
                textAlign: 'center',
                background: 'var(--rose-700)',
                color: '#FFF',
                fontSize: 14,
                letterSpacing: '.06em',
                padding: 15,
                borderRadius: 'var(--radius-pill)',
                border: 'none',
                cursor: 'pointer',
                fontFamily: 'inherit',
              }}
            >
              Agendar cita
            </button>
            <div style={{ display: 'flex', gap: 10 }}>
              <a
                href={waLink}
                target="_blank"
                rel="noreferrer"
                style={{
                  flex: 1,
                  textAlign: 'center',
                  background: '#FFF',
                  border: '1px solid var(--rose-300)',
                  color: 'var(--rose-700)',
                  fontSize: 13.5,
                  letterSpacing: '.06em',
                  padding: 14,
                  borderRadius: 'var(--radius-pill)',
                }}
              >
                WhatsApp
              </a>
              <a
                href={telLink}
                style={{
                  flex: 1,
                  textAlign: 'center',
                  background: '#FFF',
                  border: '1px solid var(--rose-300)',
                  color: 'var(--rose-700)',
                  fontSize: 13.5,
                  letterSpacing: '.06em',
                  padding: 14,
                  borderRadius: 'var(--radius-pill)',
                }}
              >
                Llamar
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
